import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './SimpleButton.module.scss';

const SimpleButton = ({
  icon,
  className,
  text,
  textColor = 'gray',
  ...props
}) => {
  return (
    <Button
      {...props}
      className={cn(styles.button, styles[textColor], className)}
    >
      {text && text} {icon && icon}
    </Button>
  );
};

export default SimpleButton;
